import { API } from '@/api/config';
import { useQuery } from '@tanstack/react-query';

export const useBranchVersion = () => {
  return useQuery({
    queryKey: ['getBranchVersionAssignment'],
    queryFn: async () => {
      return await API.get('superadmin/branch-versions/');
    },
  });
};
